import { defineMessages } from 'react-intl';

export default defineMessages({
	rootBreadcrumbName: {
		defaultMessage: 'Home',
		description:
			'The text is shown as the root breadcrumb label linking back to the help center home page in the breadcrumbs navigation element.',
		id: 'cv.help-center.breadcrumbs.element.name',
	},
});
